// extracted by mini-css-extract-plugin
module.exports = {"postsContent":"Index_postsContent__WTYz0","t-head1":"Index_t-head1__FS_GD","t-head2":"Index_t-head2__L0vRl"};